import { useQuery } from '@apollo/client';
import {
    Pack,
    Repack,
    SimilarPacksQuery,
    SimilarPacksQueryVariables,
} from 'types/generated/graphql';
import { SimilarPacks } from 'apollo/pack/pack.gql';
import { PackCardConfig } from 'components/GenericCarousel/GenericCarousel.config';

export type DetailedPacks = 'DetailedPacks';

export const usePackDetailsCarousel = ({
    item,
    skip,
}: {
    item: Pack | Repack;
    skip: boolean;
}) => {
    const { loading, error, data } = useQuery<
        SimilarPacksQuery,
        SimilarPacksQueryVariables
    >(SimilarPacks, {
        skip,
        variables: { packSlugOrGuid: item.guid },
    });

    const packsOrRepacks: Pack[] | Repack[] | undefined =
        data?.similarPacks?.data?.filter(
            (item): item is Pack => item !== undefined,
        );

    return {
        data: packsOrRepacks,
        error,
        loading,
        cardConfig: PackCardConfig,
        cardComponent: PackCardConfig.cardComponent,
    };
};
